import { Box, Chip } from '@mui/material'
import React from 'react'
import { green } from '../../../../colors'
import { type ISurveySection } from '../../../../store/slices/SurveyTemplateSlice'

interface IsRepeatPerInstructorProps {
  section: ISurveySection
}
const IsRepeatPerInstructor: React.FC<IsRepeatPerInstructorProps> = ({ section }) => {
  if (!section?.isRepeatPerInstructor) {
    return <></>
  }

  const label = (
    <>
      Repeat per Instructor
      {section?.isSelectInstructorEnabled && (
        <Box component="span" sx={{ fontWeight: 600, display: 'inline', ml: 0.5 }}>
          : User Select
        </Box>
      )}
    </>
  )

  return (
    <Chip
      label={label}
      variant="filled"
      size="small"
      color="success"
      sx={{
        borderRadius: '6px',
        border: `1px solid ${green[50]}`,
        fontWeight: 500,
        color: green[100],
        backgroundColor: green[0]
      }}
    />
  )
}

export default React.memo(IsRepeatPerInstructor)
